export default __webpack_public_path__ + "static/media/kitchen3-afterH-2048w.0a4f9254.png";